import React, { useEffect } from 'react';
import SearchSection from '../../../components/hotel/SearchSection';
import './list.scss';
import HotelList from '../../../components/hotel/HotelList';
import HotelListVip from '../../../components/hotel/HotelListVip';

export default function HotelListPage() {
  useEffect(() => {
    if (document.querySelector('#background')) {
      document.querySelector('#background').classList.add('background-image');
    }
    document.addEventListener('click', () => {
      // document.querySelector('#pop_up').style.display = 'none';
    });
    return function cleanup() {
      if (document.querySelector('#background')) {
        document.querySelector('#background').classList.remove('background-image');
      }
    };
  }, []);
  return (
    <>
      <SearchSection />
      <HotelListVip />
      <HotelList />
    </>
  );
}
